import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './plugins/vant.js'
import './plugins/common.css'
import {get,post,post_file,patch,dele,getParam,setStore,getStore} from './http/http.js'
import {formatUTC,priceFormat,systemInfo,wxshare} from './plugins/common.js'

Vue.config.productionTip = false

Vue.prototype.$post = post;
Vue.prototype.$post_file = post_file;
Vue.prototype.$patch = patch;
Vue.prototype.$get = get;
Vue.prototype.$dele = dele;
Vue.prototype.$getParam = getParam;
Vue.prototype.$setStore = setStore;
Vue.prototype.$getStore = getStore;
Vue.prototype.$formatUTC = formatUTC;
Vue.prototype.$priceFormat = priceFormat;
Vue.prototype.$systemInfo = systemInfo;
Vue.prototype.$wxshare = wxshare;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

// 加入百度统计
router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
});
